module.exports = __webpack_public_path__ + "img/coupon-3-line.9552f4c1.svg";